import styled from 'styled-components';

export const ContentRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 12px;
`;
